module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-Semibold-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-Semibold-webfont.svg
// module id = 364
// module chunks = 0